import { Component } from '@angular/core';
import { ActivatedRoute, Router, GuardsCheckStart } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Subject, filter, takeUntil, tap } from 'rxjs';
import { errorSelectors } from '../selectors';
import { errorActions } from '../actions';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "@angular/router";
import * as i3 from "@angular/common";
import * as i4 from "@angular/material/legacy-card";
import * as i5 from "../error-item/error-item.component";
function ErrorContainerComponent_app_error_item_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-error-item", 2);
    i0.ɵɵlistener("onDismiss", function ErrorContainerComponent_app_error_item_0_Template_app_error_item_onDismiss_0_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.dismissError($event)); });
    i0.ɵɵtext(1, "\n");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const error_r3 = ctx.$implicit;
    i0.ɵɵproperty("error", error_r3);
} }
function ErrorContainerComponent_mat_card_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-card");
    i0.ɵɵtext(1, "\n  No current errors\n");
    i0.ɵɵelementEnd();
} }
export class ErrorContainerComponent {
    constructor(store, route, router) {
        this.store = store;
        this.route = route;
        this.router = router;
        this.destroyed$ = new Subject();
        this.errors$ = this.store.pipe(select(errorSelectors.getAllErrors));
        this.hasError$ = this.store.pipe(select(errorSelectors.getHasError), tap(hasError => {
            if (!hasError) {
                this.router.navigate(['/']);
            }
        }));
        this.route.data.pipe(takeUntil(this.destroyed$)).subscribe(data => {
            this.doNotClearOnDestory = data.doNotClearOnDestroy;
        });
        this.router.events
            .pipe(takeUntil(this.destroyed$), filter(event => event instanceof GuardsCheckStart))
            .subscribe(() => {
            if (!this.doNotClearOnDestory) {
                this.store.dispatch(new errorActions.Clear());
            }
        });
    }
    dismissError(error) {
        this.store.dispatch(new errorActions.Remove(error));
    }
    ngOnDestroy() {
        if (!this.doNotClearOnDestory) {
            this.store.dispatch(new errorActions.Clear());
        }
        this.destroyed$.next(true);
    }
    static { this.ɵfac = function ErrorContainerComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ErrorContainerComponent)(i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i2.Router)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ErrorContainerComponent, selectors: [["app-error-container"]], standalone: false, decls: 6, vars: 6, consts: [[3, "error", "onDismiss", 4, "ngFor", "ngForOf"], [4, "ngIf"], [3, "onDismiss", "error"]], template: function ErrorContainerComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ErrorContainerComponent_app_error_item_0_Template, 2, 1, "app-error-item", 0);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵtext(2, "\n");
            i0.ɵɵtemplate(3, ErrorContainerComponent_mat_card_3_Template, 2, 0, "mat-card", 1);
            i0.ɵɵpipe(4, "async");
            i0.ɵɵtext(5, "\n");
        } if (rf & 2) {
            i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(1, 2, ctx.errors$));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(4, 4, ctx.hasError$));
        } }, dependencies: [i3.NgForOf, i3.NgIf, i4.MatLegacyCard, i5.ErrorItemComponent, i3.AsyncPipe], styles: ["\n\n[_nghost-%COMP%] {\n  display: flex;\n  margin: 16px;\n}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ErrorContainerComponent, { className: "ErrorContainerComponent", filePath: "libs/web/angular/shared/util/error-handling/src/lib/error-container/error-container.component.ts", lineNumber: 17 }); })();
//# sourceMappingURL=error-container.component.js.map